<template>
  <div class="uan-widget" @click="dialNumber">
    <div class="uan-circle">
      <div class="uan-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </svg>
      </div>
      <div class="uan-text">
        <span class="label">UAN Number</span>
        <span class="number">11 1354947</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UANWidget',
  methods: {
    dialNumber() {
      window.location.href = 'tel:111354947';
    }
  }
}
</script>

<style scoped>
.uan-widget {
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 9999;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.uan-circle {
  background: linear-gradient(135deg, #ff3b3b 0%, #d32f2f 100%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(211, 47, 47, 0.4);
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.uan-icon {
  transition: all 0.5s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uan-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  pointer-events: none;
  left: 65px;
}

.label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  opacity: 0.9;
  margin-bottom: -2px;
}

.number {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.uan-widget:hover .uan-circle {
  width: 220px;
  border-radius: 30px;
  padding: 0 25px;
  justify-content: flex-start;
  background: linear-gradient(135deg, #ff3b3b 0%, #b71c1c 100%);
  box-shadow: 0 12px 40px rgba(211, 47, 47, 0.5);
}

.uan-widget:hover .uan-icon {
  transform: rotate(360deg) scale(1.1);
}

.uan-widget:hover .uan-text {
  opacity: 1;
  transform: translateX(0);
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 15px rgba(211, 47, 47, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0);
  }
}

.uan-circle {
  animation: pulse 2.5s infinite ease-in-out;
}

.uan-widget:hover .uan-circle {
  animation: none;
  transform: scale(1.02);
}

/* Responsive adjustment */
@media (max-width: 768px) {
  .uan-widget {
    bottom: 25px;
    left: 25px;
  }
  .uan-circle {
    width: 55px;
    height: 55px;
  }
  .uan-widget:hover .uan-circle {
    width: 200px;
  }
  .number {
    font-size: 16px;
  }
}
</style>
